module.exports = __webpack_public_path__ + "static/paneheader-960a82caace856cf9f23a67a65269aac.png";